<div class="clearfix">
    <div class="container">
        <div class="clsTermConditions">
            <h1>Communication & Operations Mobile Engagement Tool Terms and Conditions</h1>
            <p>
                These Terms and Conditions constitute a legally binding agreement ("Agreement") made between you, whether personally as
                a professional, or on behalf of an entity you represent ("You" or "Customer") and Cardinality.Al whose principal place
                of business is VA, U.S.A. ("Cardinality", "we," "us" or "our"), concerning your access to and contracting a PICS
                offering ("Product").
            </p>

            <p>
                Nothing in these Terms and Conditions will alter, amend, or otherwise affect the rights and responsibilities of
                Cardinality AI and The West virginia Division of Family Children Services (“DFCS”) in accordance with any existing agreement
                related to Communication & Operations Mobile Engagement Tool or as detailed in the End User License Agreement (“EULA”).
            </p>

            <div class="clearfix">
                <h2> Confidentiality agreement: </h2>

                <p>
                    You agree that by contracting our Product, you have read, understood, and agree to be bound by these Terms and
                    Conditions, which may be executed via electronic signature, electronic online communications, or via emailed PDF-format
                    document.
                </p>

                <p>
                    You agree that you shall maintain strictly confidential, and shall not reveal nor by any means transfer to a third
                    party, or use any and all information related to the Services, products, materials, and prototypes, and any technical
                    documentation that forms part of the Know-how of Product, or that it has received from third parties, or any other
                    information to which you have access by virtue of accepting these terms.
                </p>

                <p>
                    You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any
                    laws in your jurisdiction (including but not limited to copyright laws).
                </p>
            </div>

            <div class="clearfix">
                <h2> Data usage &amp; protection: </h2>

                <p>
                    You agree to comply with applicable data usage and protection laws in relation to the Product. Data usage policy is
                    primarily concerned with privacy and compliance and exists to ensure that the data you collect, use, and store is not
                    abused. Legislation such as HIPAA have very strict guidelines on how customer data can be used, and non-compliance can
                    have serious very strict consequences.
                </p>

                <p>
                    This ties into the access policy, since employees, contractors, and other workers should only be able to access data
                    they require to do their jobs. You should also have strict guidelines in place regarding who is able to update data and
                    under what circumstances they are allowed to do so.
                </p>

                <p>
                    Data Usage Policy is designed to let you know how we collect, use, and disclose information through the websites, mobile
                    applications, and other online services and products.
                </p>

                <p class="mb-2">
                    All data obtained and held by us must be processed according to a set of core principles. In accordance with these
                    principles, we will ensure that:
                </p>

                <ul class="clearfix ps-4">
                    <li> Processing will be fair, lawful and transparent </li>
                    <li> Data collected for specific, explicit, and legitimate purposes </li>
                    <li> Data collected will be adequate, relevant and limited to what is necessary for the purposes of processing </li>
                    <li> Data will be kept accurate and up to date. Data which is found to be inaccurate will be rectified or erased without delay Data is not kept for longer than is necessary for its given purpose </li>
                    <li> Data will be processed in a manner that ensures appropriate security of personal data including protection against unauthorized or unlawful processing, accidental loss, destruction or damage by using appropriate technical or organization measures </li>
                </ul>
            </div>

            <div class="clearfix">
                <h2> Disclaimer of warranties; Limitation of liability: </h2>

                <p>
                    We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or
                    error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate or
                    reliable.
                </p>

                <p>
                    You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any
                    time, without notice to you.
                </p>

                <p>
                    You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all
                    products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and
                    'as available' for your use, without any representation, warranties, or conditions of any kind, either express or
                    implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a
                    particular purpose, durability, title, and non-infringement.
                </p>
            </div>

            <div class="clearfix">
                <h2> Severability: </h2>

                <p>
                    If any provision of these Terms of Service is determined to be unlawful, void, or unenforceable, such provision shall
                    nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be
                    deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of
                    any other remaining provisions.
                </p>
            </div>

            <div class="clearfix">
                <h2> Governing law: </h2>

                <p>
                    These Terms shall be governed and construed in accordance with the laws of West virginia, United States, without regard to its
                    conflict of law provisions.
                </p>

                <p>
                    Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any
                    provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will
                    remain in effect.
                </p>
            </div>

            <div class="clearfix">
                <h2> Changes: </h2>

                <p>
                    By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised
                    terms. If you do not agree to the new terms, you are no longer authorized to use the Service.
                </p>

                <p>
                    If you have any questions about these Terms, please contact us at <a href="mailto:comet@dohs.wv.gov">COMET</a>.
                </p>
            </div>
        </div>
    </div>
</div>